<script>
import { BellAlertIcon, BellSlashIcon } from "@heroicons/vue/24/solid";
import { defineComponent, ref } from "vue";
import NotificationsService from "@src/services/notifications.js";

export default defineComponent({
    components: { BellAlertIcon, BellSlashIcon },

    props: {
        type: {
            type: String,
            required: true
        }
    },

    setup(props) {

        function getValue() {
            if (props.type === "bots") {
                return NotificationsService.getNotifyBots();
            }

            if (props.type === "groups") {
                return NotificationsService.getNotifyGroups();
            }
        }

        function setValue(value) {
            if (props.type === "bots") {
                NotificationsService.setNotifyBots(value);
            }

            if (props.type === "groups") {
                NotificationsService.setNotifyGroups(value);
            }
        }

        const isNotifying = ref(getValue());

        function enableNotify() {
            setValue(true);
            isNotifying.value = true;
        }

        function disableNotify() {
            setValue(false);
            isNotifying.value = false;
        }

        return {
            isNotifying,
            enableNotify,
            disableNotify
        };
    }
});
</script>

<template>
    <div v-if="isNotifying" @click="disableNotify">
        <BellAlertIcon
            class="w-[22px] h-[22px] text-brand-400 mr-3 hover:text-brand-500 cursor-pointer swing-icon"
        />
    </div>

    <div v-else @click="enableNotify">
        <BellSlashIcon
            class="w-[22px] h-[22px] text-gray-500 mr-3 hover:text-brand-400 cursor-pointer swing-icon"
        />
    </div>
</template>

<style>
@keyframes swing {
  0%   { transform: rotate(0deg); }
  15%  { transform: rotate(15deg); }
  30%  { transform: rotate(-12deg); }
  45%  { transform: rotate(10deg); }
  60%  { transform: rotate(-8deg); }
  75%  { transform: rotate(5deg); }
  90%  { transform: rotate(-3deg); }
  100% { transform: rotate(0deg); }
}

.swing-icon:hover {
  animation: swing 0.9s ease-in-out;
  transform-origin: top center;
}
</style>